import { UserRole } from '@/features/users/types/user'

export const ADMIN_ROLES = [UserRole.Admin]
export const STAFF_ROLES = [UserRole.Admin, UserRole.User]
export const REPAIR_ROLES = [UserRole.Admin, UserRole.User, UserRole.Maintainer]
export const QUOTE_ROLES = [UserRole.Admin, UserRole.Vendor]
